// extracted by mini-css-extract-plugin
module.exports = {"flash-sale-pages":"flash-sale_flash-sale-pages__3OEnk"};